import Api from "@/helpers/fetch";

export default class WardApis {
    /**
     * Get all wards
     * @param {Function} callback - The callback function to handle the response
     */
    static async getAllWards({callback}) {
        const url = "churchapp/v1/page/wards";
        const res = await Api.fetch({
            url,
            method: "GET",
        })

        if (res) callback(res);
    }
}